/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An object that captures all user groups created for that client
 * @export
 * @interface UserGroups
 */
export interface UserGroups {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof UserGroups
     */
    allClientContactsGroupRID?: string;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof UserGroups
     */
    allPrimaryClientContactsGroupRID?: string;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof UserGroups
     */
    serviceTeamGroupRID?: string;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof UserGroups
     */
    primaryServiceTeamGroupRID?: string;
}

/**
 * Check if a given object implements the UserGroups interface.
 */
export function instanceOfUserGroups(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserGroupsFromJSON(json: any): UserGroups {
    return UserGroupsFromJSONTyped(json, false);
}

export function UserGroupsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroups {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allClientContactsGroupRID': !exists(json, 'allClientContactsGroupRID') ? undefined : json['allClientContactsGroupRID'],
        'allPrimaryClientContactsGroupRID': !exists(json, 'allPrimaryClientContactsGroupRID') ? undefined : json['allPrimaryClientContactsGroupRID'],
        'serviceTeamGroupRID': !exists(json, 'serviceTeamGroupRID') ? undefined : json['serviceTeamGroupRID'],
        'primaryServiceTeamGroupRID': !exists(json, 'primaryServiceTeamGroupRID') ? undefined : json['primaryServiceTeamGroupRID'],
    };
}

export function UserGroupsToJSON(value?: UserGroups | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allClientContactsGroupRID': value.allClientContactsGroupRID,
        'allPrimaryClientContactsGroupRID': value.allPrimaryClientContactsGroupRID,
        'serviceTeamGroupRID': value.serviceTeamGroupRID,
        'primaryServiceTeamGroupRID': value.primaryServiceTeamGroupRID,
    };
}

